"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3983 4H8v2h2.3983L11 7.1353V17.5H8.355c-.2284-.7677-.7132-1.425-1.355-1.8727V12h2v-2H4v2h1v3c-1.933 0-3.5 1.567-3.5 3.5S3.067 22 5 22c1.5855 0 2.9248-1.0543 3.355-2.5h4.7899c.4303 1.4457 1.7696 2.5 3.3551 2.5 1.933 0 3.5-1.567 3.5-3.5a3.538 3.538 0 0 0-.0354-.5H22v-8l-8.4377-2.3012-1.3969-2.6354A2 2 0 0 0 10.3983 4zM5 20c.8284 0 1.5-.6716 1.5-1.5S5.8284 17 5 17s-1.5.6716-1.5 1.5S4.1716 20 5 20zm13-1.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5z"
  })];
};

exports.default = _default;